/**
 * quiz C 端路由
 * play: quiz 入口页（自分流到答题态或当前记录查看态）
 * completion-record: 当前完成记录查看页
 */
const quizRoutes = [
  {
    path: '/quiz/play',
    name: 'QuizPlay',
    component: () => import('@/views/quiz/play'),
    meta: { title: '调研问卷' }
  },
  {
    path: '/quiz/completion-record',
    name: 'QuizCompletionRecord',
    component: () => import('@/views/quiz/completion-record'),
    meta: { title: '调研问卷' }
  }
]

export default quizRoutes
